import React from 'react'

const Flame = props => (
  <svg viewBox="0 0 38 65" {...props}>
    <path d="M36.8 19.1c-.8-2.5-1.8-4.6-3.1-6.5-1.3-1.8-2.9-3.6-4.8-5.3-1.9-1.6-3.8-3-5.8-4.3-1.7-1-3.6-2-5.7-3-.4-.2-.8.2-.6.6C18.3 3.8 19 6.6 19 9c0 1.5-.3 2.8-1 4.2-.7 1.3-1.6 2.5-2.7 3.5s-2.4 2.1-3.7 3.1c-1.4 1-2.7 2.1-4.1 3.3-1.4 1.2-2.6 2.5-3.7 3.8-1.1 1.3-2 2.9-2.7 4.8-.7 1.9-1 4-1 6.2 0 2.8.4 5.4 1.2 7.9.8 2.5 1.8 4.6 3.1 6.5 1.3 1.8 2.9 3.6 4.8 5.3 1.9 1.7 3.9 3.1 5.9 4.3 1.3.8 4.1 2.2 5.7 3 .4.2.8-.2.6-.6-1.5-3.2-2.2-6-2.2-8.4 0-1.5.3-2.8 1-4.2.7-1.3 1.6-2.5 2.7-3.5s2.4-2.1 3.7-3.1c1.4-1 2.7-2.1 4.1-3.3 1.4-1.2 2.6-2.5 3.7-3.8 1.1-1.3 2-2.9 2.7-4.8.7-1.9 1-4 1-6.2-.1-2.8-.5-5.4-1.3-7.9z" />
  </svg>
)

export default Flame